// 1. Imports
import { Container, Stack } from "@mui/material";
import { Page } from "../../../../components";
import HeaderBreadcrumbs from "../../../../components/header-breadcrumbs";
import { MessageHistoryList } from "../../../../components/lists/message-center-list/message-history-list";

// 2. Component Def
export const MessageHistoryScreen: React.FC = () => {
    return (
        <Page title="POM Safe - Message History">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Message History"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'View all sent and scheduled messages', href: '/messages/history' },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <MessageHistoryList />
            </Container>
        </Page>
    );
};